import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { loginSchema } from '../schemas';
import { FaEnvelope, FaLock } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import Logo from "../assets/images/logo.webp";
import Authimg from '../assets/images/loginbg.png';
import { postLogin } from '../apiservices/ApiServices';
import Loader from '../components/Loader/Loader';

const initialValues = {
    email: '',
    password: '',
}

const Login = () => {
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('useToken')) {
            navigate("/home");
        }
    }, [navigate])

    const Logins = async (values) => {
        setLoading(true);
        let postdata =
        {
            "email": values.email,
            "password": values.password,
        }
        try {
            const res = await postLogin(postdata);

            localStorage.setItem('useToken', res.data.token);
            localStorage.setItem('useData', JSON.stringify(res.data.user));

            toast.success(res.data.message);
            setLoading(false);
            setTimeout(() => window.location.reload(), 3000);

        } catch (error) {
            setLoading(false);
            toast.error(error.response.data.message);
        }
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: loginSchema,
        onSubmit: (values) => {
            Logins(values);
        }
    })

    return (
        <section id='auth'>
            <ToastContainer />
            <div className='auth-block'>
                <div className='auth-imgshap'>
                    <div className='auth-img'>
                        <img src={Authimg} alt='authimage' />
                    </div>
                </div>
                <div className='auth-froms'>
                    <div className='authboxs'>
                        <div className='logoimgs'>
                            <Link to={'/'}>
                                <img src={Logo} alt='' title='' />
                            </Link>
                        </div>
                        <div className='forms_boxs'>
                            <div className='titles'>
                                <h2>Sign In</h2>
                                <p>Welcome back to your account.</p>
                            </div>
                            <form id='loginform' onSubmit={handleSubmit} autoComplete="off">
                                <div className='form-group'>
                                    <div className="control has-icon">
                                        <label className="label auth-label" htmlFor="v-field-1">Email Address</label>
                                        <input type="email"
                                            id="email"
                                            name="email"
                                            className="input v-input"
                                            autoComplete='off'
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.email && touched.email ? (
                                            <p className='errormsg'>{errors.email}</p>
                                        ) : null}
                                        <label className="label form-icon" htmlFor="v-field-1">
                                            <FaEnvelope />
                                        </label>
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <div className="control has-icon">
                                        <label className="label auth-label" htmlFor="v-field-2">Password</label>
                                        <input type="password"
                                            id="password"
                                            name="password"
                                            className="input v-input"
                                            autoComplete='off'
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.password && touched.password ? (
                                            <p className='errormsg'>{errors.password}</p>
                                        ) : null}
                                        <label className="label form-icon" htmlFor="v-field-1">
                                            <FaLock />
                                        </label>
                                    </div>
                                </div>
                                <div className='buttonbox'>
                                    <button type='submit' className='btn btn-orange'>Login</button>
                                    <Link className='links' to={'/forgot-password'}>Forgot Password?</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <Loader />
            ) : null}
        </section>
    );
}

export default Login